<template>
  <v-form ref="form" lazy-validation @submit.prevent="onSignin">
    <v-card-text>
      <v-row>
        <v-col v-if="project.form.signInDescription" cols="12" v-html="project.form.signInDescription" />
        <v-col v-else cols="12">
          {{ $t('v.signIn') }}
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-text-field v-model="emailModel" :solo="project.form.solo" :outlined="project.form.outlined" :rules="emailRules" label="Email" name="email" type="email" required autofocus autocapitalize="none" autocomplete="username" :dense="project.form.small" @keydown.native.space.prevent />
        </v-col>
      </v-row>

      <v-row align="center">
        <v-spacer />
        <v-col cols="auto">
          <v-btn :small="project.form.small" :loading="loading" :disabled="loading" color="accent" class="px-11" type="submit">
            {{ $t('v.send') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import StepMixin from './StepMixin'
import { isEmail } from '@/helpers'

export default {
  mixins: [
    StepMixin
  ],

  data: () => ({
    email: '',
    loading: false
  }),

  computed: {
    emailModel: {
      get () {
        return this.email
      },
      set (value) {
        this.email = value ? value.replace(/\s/g, '') : ''
      }
    },

    emailRules () {
      return [v => !!v || this.$t('v.emailRequired'), v => isEmail(v) || this.$t('v.emailInvalid')]
    },

    ...mapGetters({
      project: 'projects/project'
    })
  },

  async mounted () {
    const prefillEmail = await this.usePrefillEmail()
    if (prefillEmail) {
      this.email = prefillEmail
      setTimeout(() => this.onSignin(), 50)
    }
  },

  methods: {
    async onSignin () {
      if (!this.$refs.form.validate()) {
        return false
      }

      try {
        this.loading = true

        const email = this.email.toLowerCase().trim()

        const check = await this.checkUserExistsSn({ email })

        this.next({ email, check })
      } catch (error) {
        this.showSnError(error.message)
        this.$logError(error)
      } finally {
        this.loading = false
      }
    },

    ...mapActions({
      checkUserExistsSn: 'auth/checkUserExistsSn',
      usePrefillEmail: 'auth/usePrefillEmail',
      showSnError: 'auth/showSnError',
      wdotAdd: 'wdots/add'
    })
  }
}
</script>

<style scoped>
</style>
